import { render, staticRenderFns } from "./Scatterplot.vue?vue&type=template&id=2932c9c2&"
import script from "./Scatterplot.vue?vue&type=script&lang=js&"
export * from "./Scatterplot.vue?vue&type=script&lang=js&"
import style0 from "./Scatterplot.vue?vue&type=style&index=0&id=2932c9c2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2932c9c2')) {
      api.createRecord('2932c9c2', component.options)
    } else {
      api.reload('2932c9c2', component.options)
    }
    module.hot.accept("./Scatterplot.vue?vue&type=template&id=2932c9c2&", function () {
      api.rerender('2932c9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Scatterplot.vue"
export default component.exports